import BaseLayout from '@/components/BaseLayout.vue';
import api from '@/services/api';
import router from '@/router';
import {mapActions, mapGetters} from 'vuex';

export default {
    name: 'editNewPromotionBaseSettings',
    data() {
        return {
            imageId: null,
            promotionType: 1,
            showLoader: false,
        }
    },

    components: {
        BaseLayout,
    },

    computed: {
        ...mapGetters({
            promotion: 'promotion/promotion',
        }),

        imageSrc() {
            if (this.promotion.activePromotion && this.promotion.activePromotion.promotion_stand.file_url) {
                return this.promotion.activePromotion.promotion_stand.file_url;
            }

            return '';
        },
    },

    methods: {
        ...mapActions('promotion', ['storePromotion']),
        /**
         * Set image in data object when user upload image
         * @param event
         */
        uploadImage(event) {
            let formData = new FormData();
            formData.append('file', event.target.files[0])
            this.showLoader = true;
            api.post('/api/assets', formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    this.imageId = response.data.body.entry.id;
                    this.showLoader = false;
                })
                .catch((error) => {
                    this.showLoader = false;
                });
        },

        /**
         * Edit promotion and send to our backend
         */
        editPromotion() {
            const params = new FormData();
            params.append('type', 1);
            params.append('promotion_with_gifts', this.promotionType);
            if(this.imageId) {
                params.append('promotion_stand', this.imageId);
            }

            api.post(`/api/promotions_edit`, params)
                .then(() => {
                    this.storePromotion();
                    router.replace('/promotion')
                })
                .catch((error) => {
                });
        },

        /**
         * Send user back
         */
        goBack() {
            router.replace('/promotion')
        },
    },

    watch: {
        'promotion.activePromotion.promotion_with_gifts': function (){
            this.promotionType = this.promotion.activePromotion.promotion_with_gifts;
        }
    },

    mounted() {
        if (this.promotion.activePromotion) {
            this.promotionType = this.promotion.activePromotion.promotion_with_gifts;
        }
    },
}